import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    Box,
    styled
} from '@mui/material';
import { getShopifyID } from '../../utils/utils';
import { QuantitySelector } from '../shared/QuantitySelector';
import { Product } from '../../models/Product';
import { CollectionProductTitle } from './CollectionProductItem/CollectionProductTitle';
import { CollectionProductStockStatus } from './CollectionProductItem/CollectionProductStockStatus';
import { CollectionProductNetPrice } from './CollectionProductItem/CollectionProductNetPrice';
import { CollectionProductAddToQuotation } from './CollectionProductItem/CollectionProductAddToQuotation';
import { CollectionProductImage } from './CollectionProductItem/CollectionProductImage';
import { ProductStockLocation } from '../../models/ProductStock';

const StyledWrapper = styled(Box)(({ theme }) => ({
    border: '1px solid #f5f5f5',
    borderRadius: '5px',
    padding: '10px',
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    columnGap: '10px',
}));

const StyledBox = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    gap: '10px',
}));

const StyledImage = styled(Box)(() => ({
    width: '90px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    img: {
        maxWidth: '100%',
    },
}));

const StyledContent = styled(Box)(({ theme }) => ({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    [theme.breakpoints.down('md')]: {
        alignItems: 'start',
        flexDirection: 'column',
        width: '100%',
    },
}));

const StyledTitle = styled(Box)(({ theme }) => ({
    width: '60%',
    paddingLeft: '10px',
    [theme.breakpoints.only('md')]: {
        width: '40%',
    },
    [theme.breakpoints.down('md')]: {
        width: '100%',
    },
}));

export const CollectionListProductItem = (props: ProductProps) => {
    const { product, productQuantity, handle } = props;
    const variant = product.variants.nodes[0];
    const [qty, setQty] = useState(1);

    const handleChange = (qty) => {
        setQty(qty);
    };

    if (product.customPrices) {
        variant.price.amount = product.customPrices.prices.find(
            (elem) => elem.variantId == getShopifyID(variant.id)
        ).price;
    }

    return (
        <StyledWrapper>
            <StyledImage>
                <CollectionProductImage product={product} />
            </StyledImage>
            <StyledContent>
                <StyledTitle>
                    <CollectionProductTitle
                        product={product}
                        collectionHandle={handle}
                        variantSku={variant.sku}
                    />
                </StyledTitle>
                <StyledBox sx={{paddingLeft: '10px',}}>
                    <StyledBox>
                        <CollectionProductStockStatus
                            quantity={productQuantity}
                        />
                    </StyledBox>
                    <StyledBox sx={{ justifyContent: 'end' }}>
                        <CollectionProductNetPrice variant={variant} />
                    </StyledBox>
                    <StyledBox sx={{ justifyContent: 'center' }}>
                        <Box>
                            <QuantitySelector
                                variant={variant}
                                qtyChanged={handleChange}
                            />
                        </Box>
                    </StyledBox>
                    <StyledBox sx={{ justifyContent: 'end' }}>
                        <CollectionProductAddToQuotation
                            variant={variant}
                            quantity={qty}
                        />
                    </StyledBox>
                </StyledBox>
            </StyledContent>
        </StyledWrapper>
    );
};

type ProductProps = {
    product: Product;
    productQuantity: ProductStockLocation;
    handle: string;
};
